var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"separator text-uppercase text-center text-light"},[_c('cmsBlockSimpleTitle',{attrs:{"identifier":"header_seperator_title"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }